import * as React from 'react';
import { createRoot } from 'react-dom/client';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import { config } from '@fortawesome/fontawesome-svg-core';
import '@fortawesome/fontawesome-svg-core/styles.css';
import { RootPage } from './pages/RootPage';
import { System } from './core/System';

import { configure } from 'mobx';

configure({
  enforceActions: 'never'
});

const emotionCache = createCache({
  key: 'goferal',
  nonce: window.__webpack_nonce__
});

// Disable Font Awesome runtime CSS injection (uses innerHTML), since Trusted Types CSP blocks that path.
config.autoAddCss = false;

document.addEventListener('DOMContentLoaded', () => {
  const system = new System();
  system.init();
  const root = createRoot(document.querySelector('#application'));
  root.render(
    <CacheProvider value={emotionCache}>
      <RootPage system={system} />
    </CacheProvider>
  );
});
